'use strict';

angular.module('formonlineApp').service('DeclarationLRService', ['$http',
    function ($http) {

        this.create = function (declarationIs, file) {
            return $http({
                method: 'post',
                url: 'api/declaration/lr',
                headers: {'Content-Type': undefined },
                transformRequest: function (data) {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(declarationIs)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: declarationIs, file: file }
            });
        };

        this.download = function (declarationIs, file) {
            return $http({
                method: 'post',
                url: 'api/declaration/lr/download',
                headers: {'Content-Type': undefined },
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(declarationIs)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: declarationIs, file: file }
            });
        };

        this.check = function (declarationIs, file) {
            return $http({
                method: 'post',
                url: 'api/declaration/lr/check',
                headers: {'Content-Type': undefined },
                transformRequest: function (data) {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(declarationIs)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: declarationIs, file: file }
            });
        };

    }]);
